import { CollapsableGroup } from '@/module/AnnualReport/components/CollapsableGroup';
import { Book } from '@/module/Author/Book';
import { BookValidationAction } from '@/module/Author/Book/Validation/BookValidationAction';
import { BookCard } from '@/module/Author/Book/components/Card/BookCard';

interface CollapsableBookProps {
  title: string;
  books: Book[];
}

export function CollapsableBook({ title, books }: CollapsableBookProps) {
  return (
    <CollapsableGroup
      title={title}
      items={books}
      renderValidation={book => (
        <BookValidationAction
          variant="compact"
          bookId={book.id}
        />
      )}
      renderItem={book => (
        <BookCard
          book={book}
          onClick={() => window.open(`/author/book/${book.id}`)}
        />
      )}
    />
  );
}
